import { render } from "./ProductCard.vue?vue&type=template&id=053934fe"
import script from "./ProductCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"source/js/vue/components/sections/ProductCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "053934fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('053934fe', __exports__)) {
    api.reload('053934fe', __exports__)
  }
  
  module.hot.accept("./ProductCard.vue?vue&type=template&id=053934fe", () => {
    api.rerender('053934fe', render)
  })

}


export default __exports__